import React from 'react';

import { Picker, IconButton, AddLinkIcon } from '@gogame/components';
import { withFormField } from '@gogame/form';

const getOptionLabel = (data) => data;

export default withFormField()(({ value = '', area, onChange }) => {
  const handleChange = React.useCallback(
    ([data]) => {
      onChange(null, `${value}{${data}}`);
    },
    [onChange, value]
  );

  return (
    <Picker
      button={<IconButton icon={<AddLinkIcon />} tooltip={'Add params'} />}
      getOptionLabel={getOptionLabel}
      onChange={handleChange}
      options={area.data || []}
      loading={area.loading}
    />
  );
});
